export default "/images/Slide1.png?8aada631322bf8296793cf88bf0855a7";